import React, { memo, useEffect, useState } from 'react';

import CommonPopper from '../../../components/common-popper/CommonPopper';
import { COMMON_POPPER_MODIFIERS } from '../../../constants/popper';
import FilterList from './FilterList';
import CommonTooltipEllipses from '../../../components/common-tooltip-ellipses/CommonTooltipEllipses';
import CircleCounter from '../../../components/circle-counter/CircleCounter';

import scss from './ColumnFilter.module.scss';

function ColumnFilter({ label, options, selectedOptions, disabled, maxWidth, minWidth = '200px', onApply }) {
  const [localSelectedOptions, setLocalSelectedOptions] = useState([]);

  const selectedOptionsNum = options.reduce((num, option) => {
    if (localSelectedOptions.some(({ id }) => option.id === id)) {
      return (num += 1);
    }

    return num;
  }, 0);

  const handleApplyFilters = () => {
    if (onApply) {
      onApply(localSelectedOptions);
    }
  };

  const handleSelectFilterOption = (newOption) => {
    setLocalSelectedOptions((prevState) => {
      const isContained = prevState.some(({ id }) => id === newOption.id);

      return isContained ? prevState.filter(({ id }) => id !== newOption.id) : [...prevState, newOption];
    });
  };

  useEffect(() => {
    setLocalSelectedOptions(selectedOptions);
  }, [selectedOptions]);

  return (
    <CommonPopper
      component={() => (
        <FilterList
          options={options}
          selectedOptions={localSelectedOptions}
          maxWidth={maxWidth}
          minWidth={minWidth}
          onSelect={handleSelectFilterOption}
        />
      )}
      options={COMMON_POPPER_MODIFIERS}
      isShowCaret
      className={scss.wrapper}
      disablePortal={false}
      placement='bottom-start'
      onClose={handleApplyFilters}
      disabled={disabled}>
      <CommonTooltipEllipses toolTipText={label} label={label} className={scss['filter-label']} />
      {selectedOptionsNum ? <CircleCounter count={selectedOptionsNum} className={scss['filter-counter']} /> : null}
    </CommonPopper>
  );
}

export default memo(ColumnFilter);
